import React, { useState, useEffect } from 'react';
import { notificationService } from '../services/notificationService';

interface NavigationItem {
  id: string;
  label: string;
  icon: string;
}

interface NavigationBarProps {
  activeItem?: string;
  onNavigate: (screen: string) => void;
}

const NavigationBar: React.FC<NavigationBarProps> = ({ activeItem = 'home', onNavigate }) => {
  const [alertCount, setAlertCount] = useState(0);
  const [tutorMode, setTutorMode] = useState(false);

  useEffect(() => {
    const updateStatus = () => {
      setAlertCount(notificationService.getUnacknowledgedAlerts().length);
      setTutorMode(localStorage.getItem('calmi_profile_mode') === 'tutor');
    };
    updateStatus();
    const interval = setInterval(updateStatus, 3000);
    return () => clearInterval(interval);
  }, []);

  const items: NavigationItem[] = [
    { id: 'home', label: 'Inicio', icon: '🏠' },
    { id: 'chat', label: 'Hablar', icon: '💬' },
    { id: 'play', label: 'Jugar', icon: '🎨' },
    { id: 'diary', label: 'Diario', icon: '📖' },
    { id: 'profile', label: 'Perfil', icon: '👤' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-6 py-3">
      <div className="max-w-md mx-auto flex justify-around">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            className={`relative flex flex-col items-center p-2 ${
              item.id === activeItem ? 'text-blue-600' : 'text-gray-400'
            }`}
          >
            <span className="text-xl mb-1 relative">
              {item.icon}
              {item.id === 'profile' && tutorMode && alertCount > 0 && (
                <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                  {alertCount > 9 ? '9+' : alertCount}
                </span>
              )}
            </span>
            <span className="text-xs">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationBar;
